module.exports = __webpack_public_path__ + "img/RCT10.891034b0.svg";